import React, { useMemo } from 'react';
import { Pressable, TouchableOpacity } from 'react-native';

const CustomPressable = (props) => {
  const {
    onPress,
    children,
    style,
    disabled,
    ...otherProps
  } = props || {};


  const customStyle = useMemo(() => {
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
  }, [style]);


  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => ({
        opacity: disabled ? 0.7 : pressed ? 0.92 : 1,
        ...customStyle,
      })}
      disabled={disabled}
      {...otherProps}
    >
      <>
      {children}
      </>
    </Pressable>
  );
};


export default CustomPressable;
